import { createSelector } from 'reselect';
import _ from 'lodash';

import {
  filterBySelectedPartyListServices,
  getPartyFilterValues,
} from 'utils/service/partyListUtils';
import {
  isPartyCanceled,
  isPartyFinished,
  isPartyNoShow,
  isPartyNotComing,
  isPartySeated,
  isPartyWalkIn,
} from 'utils/partyUtils';
import { selectedPartyListServicesSelector } from 'selectors/calendarFilterSelectors';
import PartyStates from 'constants/partyStateConstants';
import partiesSelector from 'selectors/service/partiesSelector';

export interface PartyCount {
  [key: string]: number;
}

export default createSelector(
  partiesSelector,
  selectedPartyListServicesSelector,
  (parties, selectedPartyListServices): PartyCount => {
    const partiesToCount = _.filter(
      parties,
      (party) =>
        !isPartyNotComing(party) &&
        filterBySelectedPartyListServices(
          selectedPartyListServices,
          getPartyFilterValues(party).serviceType
        )
    );
    const partyCount: { [key: string]: number } = {
      [PartyStates.canceled]: 0,
      [PartyStates.expected]: 0,
      [PartyStates.left]: 0,
      [PartyStates.noshow]: 0,
      [PartyStates.seated]: 0,
      reservationCoverCount: 0,
      reservationPartyCount: 0,
      upcomingCoverCount: 0,
      upcomingPartyCount: 0,
      walkinCoverCount: 0,
      walkinPartyCount: 0,
      walkinSeatedAndFinishedPartyCount: 0,
      walkinSeatedAndFinishedCoverCount: 0,
    };

    _.forEach(partiesToCount, (party) => {
      if (isPartyWalkIn(party) && !isPartyCanceled(party)) {
        partyCount.walkinPartyCount += 1;
        partyCount.walkinCoverCount += party.partySize;
        if (isPartySeated(party) || isPartyFinished(party)) {
          partyCount.walkinSeatedAndFinishedPartyCount += 1;
          partyCount.walkinSeatedAndFinishedCoverCount += party.partySize;
        }
      } else if (!isPartyCanceled(party) && !isPartyNoShow(party)) {
        // Add to the number of covers if it's not canceled or a no show
        partyCount.reservationPartyCount += 1;
        partyCount.reservationCoverCount += party.partySize;
        if (!isPartySeated(party) && !isPartyFinished(party)) {
          partyCount.upcomingPartyCount += 1;
          partyCount.upcomingCoverCount += party.partySize;
        }
      }

      partyCount[party.state] += party.partySize;
    });
    return partyCount;
  }
);
